import React, {Component} from 'react';
import {Button, Image} from 'react-bootstrap';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {userActions as actions} from '../actions';
import TextInputBox from './TextInputBox';
import '../content/css/NoEmailGivenPage.css';
import {userConstants as constants} from "../constants";
import AuthService from "../services/auth.service";

var logo = require("../content/images/legly_logo_color.svg");

class NoEmailGivenPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: ""
        };

        this.authService = new AuthService();

        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleConfirmClick = this.handleConfirmClick.bind(this);
        this.handleConnectionButtonClick = this.handleConnectionButtonClick.bind(this);
    }

    handleEmailChange(email) {
        this.setState({email});
    }

    handleConfirmClick() {
        if (this.state.email === '') return;
        this.props.linkEmailToAccount(this.state.email);
    }

    handleConnectionButtonClick(connection) {
        if (connection == '') return;
        this.authService.login(connection);
    }

    getConnectionAlternatives() {
        return this.props.connectionNames.map(x => (
            <li>
                <a className="list-group-item btn-link text-center" onClick={() => this.handleConnectionButtonClick(x)}>{x}</a>
            </li>
        ));
    }

    render() {
        return (
            <div className="center-horizontally no-email-given-page">
                <div>
                    <Image className="logo" src={logo}/>
                    {this.props.linkEmailStatus != constants.LINK_EMAIL_OTHER_LOGIN_CONNECTION_EXISTS &&
                    <div>
                        <h3>Thank you for creating an account.</h3>
                        <h3>Please enter your email so we can verify that you are a customer.</h3>
                    </div>}
                    {this.props.linkEmailStatus == constants.LINK_EMAIL_USER_EXISTS &&
                    <p className="alert alert-warning">A user with this email already exists. Please contact <a href="mailto:support@legly.io">support@legly.io</a> for help.</p>
                    }
                    {this.props.linkEmailStatus != constants.LINK_EMAIL_OTHER_LOGIN_CONNECTION_EXISTS &&
                    <div>
                    <TextInputBox
                        helpText="Enter your email."
                        onChange={this.handleEmailChange}
                    />
                        <Button variant="secondary" onClick={this.handleConfirmClick}>Confirm</Button>
                    </div>
                    }
                    {this.props.linkEmailStatus == constants.LINK_EMAIL_OTHER_LOGIN_CONNECTION_EXISTS &&
                    <div className="alert alert-info">
                        <h3>Your email address is connected to a company Single Sign On.</h3>
                        <p>Click on a button below to sign in to Legly with your company account.</p>
                        <br />
                        <ul className="list-group list-group-sso list-unstyled">
                            {this.getConnectionAlternatives()}
                        </ul>
                    </div>
                    }

                </div>
            </div>
        );
    }
}

export default connect(
    state => state.authentication,
    dispatch => bindActionCreators(actions, dispatch)
)(NoEmailGivenPage);



// WEBPACK FOOTER //
// ./src/components/NoEmailGivenPage.js